
import {
  CompanyAddress,
  JonarAPIResponse,
  PartnerCustomsInfo,
  PartnerRepresentative,
} from "@assets/types";


import axios, { AxiosResponse } from "axios";

const JonarAPI = process.env.JonarAPI;

class CompanyService {
getPartnerDefaultAddresses = async (partnerID: string,
  ): Promise<CompanyAddress[]> => {
    return await axios
      .get(`${JonarAPI}/partner/${partnerID}/default-addresses`, {
        headers: {
          "Access-Control-Allow-Origin": "*",
        },
        withCredentials: true,
      })
      .then((res: AxiosResponse<JonarAPIResponse<CompanyAddress[]>>) => {
        return res.data.ReturnItem.Data;
      });
  };

  getPartnerRepresentatives = async (partnerCode: string): Promise<PartnerRepresentative[]> => {
  return await axios
    .get(`${JonarAPI}/partner/${partnerCode}/representatives`, {
      headers: { "Access-Control-Allow-Origin": "*" },
      withCredentials: true,
    })
    .then((res: AxiosResponse<JonarAPIResponse<PartnerRepresentative[]>>) => {
      return res.data.ReturnItem.Data;
    });
};

getPartnerCustomsInfo = async (partnerCode: string): Promise<PartnerCustomsInfo> => {
  return await axios
    .get(`${JonarAPI}/partner/${partnerCode}/customs-info`, {
      headers: { "Access-Control-Allow-Origin": "*" },
      withCredentials: true,
    })
    .then((res: AxiosResponse<JonarAPIResponse<PartnerCustomsInfo>>) => {
      return res.data.ReturnItem.Data[0] ?? null;
    });
};

}

export default new CompanyService();
